import PhoneIcon from '@mui/icons-material/Phone';
import { Box, Button, Paper, Typography } from '@mui/material';

const TelephonyPanel = () => {
    return (
        <Box>
            <Paper
                sx={{
                    p: 4,
                    textAlign: 'center',
                    background: 'linear-gradient(135deg, #ede9fe 0%, #ddd6fe 100%)',
                    borderRadius: 3,
                    boxShadow: '0 8px 32px rgba(139, 92, 246, 0.2)',
                }}
            >
                <PhoneIcon sx={{ fontSize: 80, color: '#8b5cf6', mb: 2 }} />
                <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, color: '#5b21b6' }}>
                    Телефония
                </Typography>
                <Typography variant="body1" sx={{ color: '#6b21a8', mb: 3, maxWidth: 600, mx: 'auto' }}>
                    Здесь будет интеграция с системой телефонии для управления звонками,
                    записи разговоров и аналитики общения с клиентами.
                </Typography>
                <Button
                    variant="contained"
                    sx={{
                        bgcolor: '#8b5cf6',
                        '&:hover': { bgcolor: '#7c3aed' },
                        px: 4,
                        py: 1.5,
                        fontWeight: 600,
                    }}
                >
                    Настроить интеграцию
                </Button>
            </Paper>
        </Box>
    );
};

export default TelephonyPanel;
